export const currentBrand = process.env.REACT_APP_WEBSITE_BRAND || 'vwfs';
export const integrationApiBaseUrl = process.env.REACT_APP_INTEGRATION_API_BASE_URL;
export const integrationApiBaseUrlLocal = process.env.REACT_APP_API_BASE_URL_LOCAL;
export const headlessCmsVersion = process.env.REAC_APP_HEADLESS_CMS_VERSION || 'v1';
export const fesApiBaseUrl = process.env.REACT_APP_FES_API_BASE_URL;
export const fesLocalEnvApiBaseUrl = process.env.REACT_APP_LOCAL_ENV_FES_API_BASE_URL;
export const idpHint = process.env.REACT_APP_IDP_HINT;
export const apiGatewayConsumerName = 'vwfs-du-cpie';
export const maxFileSize = 4 * 1024 * 1024;
export const isFirstRegistrationLocalStorageKey = 'isFirstRegistration';
export const isAfterRegistrationLocalStorageKey = 'isAfterRegistration';
export const lastContactDetailsHookPageKey = 'lastContactDetailsHookPage';
export const chatbotCssUrls = {
    audi: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/audi/css/widget.css',
    vwcv: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/vw6/css/widget.css',
    seat: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/seat/css/widget.css',
    skoda: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/skoda/css/widget.css',
    cupra: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/cupra/css/widget.css',
    generic: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/generic/css/widget.css',
    vwfs: 'https://cdn.bronson.vwfs.io/3rd-party-ui-extensions/chatbot/latest/v4/bluelabel/css/widget.css',
};
